// userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user_id: null,
  isEdit: false,
  isView: false,
  isDelete: false,
  table: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserForEdit: (state, action) => {
      state.user_id = action.payload.user_id;
      state.isEdit = action.payload.isEdit;
      state.table = action.payload.table;
    },
    setUserForView: (state, action) => {
      state.user_id = action.payload.user_id;
      state.isView = action.payload.isView;
      state.table = action.payload.table;
    },
    setUserForDelete: (state, action) => {
      state.user_id = action.payload.user_id;
      state.isDelete = action.payload.isDelete;
      state.table = action.payload.table;
    },
    resetUserState: (state) => {
      state.user_id = null;
      state.isEdit = false;
      state.isView = false;
      state.isDelete = false;
      state.table = false;
    },
  },
});

export const {
  setUserForEdit,
  setUserForDelete,
  setUserForView,
  resetUserState,
} = userSlice.actions;
export default userSlice.reducer;
